import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)

const router = new Router({
    mode: "history",

    base: process.env.VUE_APP_WEB_ROUTER_ROOT,

    routes: [
        {
            path: "/",
            name: "home",
            meta: {},
            component: () => import(/* webpackChunkName: "Home" */ "@/pgm/Home.vue"),
        },
        {
            path: "/result",
            name: "result",
            meta: {},
            component: () => import(/* webpackChunkName: "Result" */ "@/pgm/Result.vue"),
        },
        {
            path: "/error",
            name: "error",
            meta: {},
            component: () => import(/* webpackChunkName: "Error" */ "@/pgm/Error.vue"),
        },
        {
            path: "*",
            meta: {},
            redirect: "/error",
        },
    ],
})

export default router
